
export const removeRefListItem = (entity, property, idToRemove) => {
    return {
        ...entity,
        [property]: entity[property].filter(id => id !== idToRemove)
    };
};



// WEBPACK FOOTER //
// ./src/core/store/helpers/remove-ref-list-item.ts